import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  extend,
} from '@thd-nucleus/data-sources';
import { DrawerBody, DrawerFooter, Button } from '@one-thd/sui-atomic-components';
import { Specifications } from '@thd-olt-component-react/specifications';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { useIntentProductData } from '../../hooks/useIntentProductData';

export const ProductSpecs = ({
  itemId, updateList, isDisplayOnly, isIntent, handleResolveIntent
}) => {
  const { setScreen, addToType } = useContext(AddToContext);
  const { PROJECT_SELECT_GROUP, DEFAULT } = SCREENS;

  const { omsId, sku } = useIntentProductData({ itemId, isIntent });

  const handleSubmit = async () => {
    if (addToType === 'List') {
      await updateList({
        variables: {
          products: [{ itemId, quantity: 1 }]
        }
      });
      setScreen(DEFAULT);
    } else if (addToType === 'Project' && isIntent) {
      await handleResolveIntent({
        omsId,
        sku
      });
    } else {
      setScreen(PROJECT_SELECT_GROUP);
    }
  };

  return (
    <>
      <DrawerBody data-testid="test-productspecs">
        <Specifications itemId={itemId} hideMobileFade oneColumn />
      </DrawerBody>
      <DrawerFooter position="center">
        {!isDisplayOnly && (
          <Button
            data-testid="productSpecs-AITP-button"
            variant="secondary"
            fullWidth
            onClick={handleSubmit}
            type="submit"
          >
            Add to {addToType}
          </Button>
        )}
      </DrawerFooter>
    </>
  );
};

ProductSpecs.displayName = 'ProductSpecs';

ProductSpecs.propTypes = {
  itemId: PropTypes.string.isRequired,
  updateList: PropTypes.func,
  isDisplayOnly: PropTypes.bool,
  handleResolveIntent: PropTypes.func,
  isIntent: PropTypes.bool
};

ProductSpecs.defaultProps = {
  updateList: () => {},
  isDisplayOnly: false,
  handleResolveIntent: null,
  isIntent: false
};

ProductSpecs.dataModel = extend(Specifications, useIntentProductData);
